import React from "react";
import { connect } from "react-redux";
import LogoWithBG from "../../components/logo/LogoWithBG"
import medRef from "../../assets/img/medref.png";
import DALogo from "../../assets/img/DA_logo.png";
import DOHLogo from "../../assets/img/DOH_logo.png";
import { Link } from "react-router-dom";

const DaDohScreen = () => {
  
  return (
    <div className="m-4 flex flex-col h-full items-center justify-center px-2 pt-8 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">      
      <a href="https://patientappointment.doh.gov.ph/homepage.php">

      <LogoWithBG 
          backgroundImg={medRef}
          altBg="medicine refrigerator"
          logoImg={DOHLogo}
          altLogo="DOH Logo"
        />
      </a>
      <Link to="/auth/home">
      <LogoWithBG 
          backgroundImg={medRef}
          altBg="medicine refrigerator"
          logoImg={DALogo}
          altLogo="DOH Logo"
        />
        </Link>
    </div>
  );
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({  
});

export default connect(mapStateToProps, mapDispatchToProps)(DaDohScreen);